import angular from 'angular';
import _ from 'lodash';

class communityDetailCtrl {
    /* @ngInject */
    constructor(
        RegistrationScheme,
        RegistrationSchemesDA,
        $uibModal,
        $scope,
        $state,
        $document,
        $window,
        EMAIL_REGEXP,
        CommunitySvc,
        logger,
        $http,
        CONF,
        AuthSvc
    ) {
        this.RegistrationScheme = RegistrationScheme;
        this.RegistrationSchemesDA = RegistrationSchemesDA;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.$state = $state;
        this.$document = $document;
        this.$window = $window;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
        this.CommunitySvc = CommunitySvc;
        this.logger = logger;
        this.$http = $http;
        this.CONF = CONF;
        this.AuthSvc = AuthSvc;
        this.EID_REGEX = /^[a-zA-Z0-9_]*$/;

    }

    $onInit() {
        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };
        this._initRegSchemes();
        this.community = {};
        this.communityDto = {};

        this.id = this.$state.params.eid;
        this.edit = !!this.id; // Distingue la création de la consultation/modification
        this.saveDisabled = !this.isAuthorizedToUpdate();
        if (this.edit) {
            this.CommunitySvc.getCommunityById(this.id).then(
                data => {
                    this.community.eid = data.eid;
                    this.community.address1 = data.address1;
                    this.community.address2 = data.address2;
                    this.community.city = data.city;
                    this.community.email = data.email;
                    this.community.firstName = data.firstName;
                    this.community.lastName = data.lastName;
                    this.community.name = data.name;
                    this.community.newLogoId = data.newLogoId;
                    this.community.countryCode = data.countryCode;
                    this.community.creationDate = data.creationDate;
                    this.community.idNational = data.idNational;
                    this.community.idNationalKind = data.idNationalKind;
                    this.community.phone = data.phone;
                    this.community.alias = data.alias;
                    this.community.zipCode = data.zipCode;
                    this.community.state = data.state;
                    this.reloadRegSchemesonEdit(this.community.countryCode);
                },
                () => {
                    this.logger.error('error.search');
                }
            );
        }
        this.isReadyForDeletion = false;
        this.CommunitySvc.getAllCompaniesOfCommunity(this.id, 0, 1).then(
            data => {
                this.isReadyForDeletion = data.data.totalElements === 0  && !this.saveDisabled;
            }
        );
    }

    reloadRegSchemes(country) {
        this.reloadRegSchemesonEdit(country ? country.code : null);
    }

    reloadRegSchemesonEdit(countryCode) {
        if (countryCode) {
            this.RegistrationSchemesDA.getByCountry(countryCode).then(regShemes => {
                this.regSchemes = regShemes;
                this._initRegSchemes();
            });
        } else {
            this.regSchemes = null;
            this.natRegSchemes = null;
            this.community.idNationalKind = null;
        }
    }

    save() {
        if (this.form.$valid) {
            if (this.edit) {
                this.CommunitySvc.updateCommunity(this.community).then(
                    () => {
                        this._onSaveSuccess('success.update');
                    },
                    error => {
                        this._onSaveError(error);
                    }
                );
            } else {
                this.CommunitySvc.saveCommunity(this.community).then(
                    () => {
                        this._onSaveSuccess('success.create');
                    },
                    error => {
                        this._onSaveError(error);
                    }
                );
            }
        } else {
            this.$document[0].querySelector('input.ng-invalid').focus();
        }
    }

    _onSaveSuccess(message /*:string*/) {
        this.logger.success(message, null, null, { entityName: 'La communauté' });
        this.$state.go('community.list.main');
    }

    _onSaveError(error) {
        if (error.status === 400 && error.data) {
            switch (error.data.code) {
                case 'INVALID_NATIONAL_ID':
                    this.logger.error('error.functional.invalid_national_id');
                    break;
                case 'DUPLICATE_COMMUNITY_EID':
                    this.form.eid.$setValidity('commEidAlreadyUsed', false);
                    break;
                default:
                    break;
            }
        }
    }

    cancel() {
        this.$state.go('community.list.main');
    }

    eidChange() {
        if (this.form.eid.$error.commEidAlreadyUsed) {
            this.form.eid.$setValidity('commEidAlreadyUsed', true);
        }
    }

    isAuthorizedToUpdate() {
        return this.AuthSvc.isAuthorized('CONFIGURATOR');
    }

    _initRegSchemes() {
        this.natRegSchemes = _.filter(this.regSchemes, { scope: 'national' });
    }

    goBackToList() {
        this.$state.go('community.list.main');
    }

    /*
    * Suppression de la communauté s'il n'a pas de société adhérentes
    */
    deleteCommunity(){
        this.$uibModal
            .open({
                component: 'modalDeleteCommunity',
                size: 'md',
                resolve: {
                    community: () => {
                        return this.community;
                    },
                },
            })
            .result.then(
                () => {
                    this.goBackToList();
                },
                () => {}
            );
    }
}

angular.module('app.community').component('communityDetail', {
    templateUrl: require('./community-detail.html'),
    controller: communityDetailCtrl,
    bindings: {
        community: '<',
        countries: '<',
    },
});
